var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { RequestClient } from "../basics/request-client.service";
import * as ValidationConstants from "../../constants/validations/validations.constants";
import { BindingEngine } from "aurelia-binding";
import { toNative } from "../../utilities/promise-utils";
var ValidationsClientService = /** @class */ (function () {
    function ValidationsClientService(requestClient, bindingEngine) {
        this.requestClient = requestClient;
        this.bindingEngine = bindingEngine;
        this.validationRules = {};
        this.cacheFlag = []; // if an entitytype is being loaded, the entitytype is added here until loading is complete
        this.validationRules = {};
    }
    ValidationsClientService.prototype.validateChildEntity = function (request) {
        return toNative(this.requestClient.post(ValidationConstants.Urls.ValidateChildEntity, {}, request));
    };
    ValidationsClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(ValidationConstants.Urls.SaveValidationRulesForLevel, {}, request));
    };
    ValidationsClientService.prototype.validate = function (request) {
        return toNative(this.requestClient.post(ValidationConstants.Urls.Validate, {}, request));
    };
    ValidationsClientService.prototype.getValidationRulesForLevel = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient
                .post(ValidationConstants.Urls.GetValidationRulesForLevel, {}, request)
                .then(function (response) {
                resolve(response);
            }, reject);
        });
    };
    ValidationsClientService.prototype.getValidationRootTypes = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.get(ValidationConstants.Urls.GetValidationRootEntities, null, null).catch(function (response) {
                resolve(response);
            }).catch(function (ex) {
                reject(ex);
            });
        });
    };
    ValidationsClientService.prototype.getValidationRules = function (entityType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.validationRules[entityType]) { // data is already loaded
                resolve(_this.validationRules[entityType]);
            }
            else {
                if (_this.cacheFlag.indexOf(entityType) !== -1) { // data is being loaded, wait until it is complete
                    var subscription_1 = _this.bindingEngine.collectionObserver(_this.cacheFlag)
                        .subscribe(function (newValue) {
                        if (newValue.indexOf(entityType) === -1) {
                            _this.getValidationRules(entityType).then(function (response) {
                                resolve(response);
                            });
                            // resolve(this.validationRules[entityType]);
                            subscription_1.dispose();
                        }
                    });
                }
                else { //data not available locally, fetch from server
                    _this.cacheFlag.push(entityType);
                    _this.getValidationRulesInternal({ entityTypeToFilter: entityType })
                        .then(function (result) {
                        _this.validationRules[entityType] = result.validationRules;
                        resolve(result.validationRules);
                        _this.cacheFlag.splice(_this.cacheFlag.indexOf(entityType), 1);
                    }).catch(function (e) {
                        reject(e);
                    });
                }
            }
        });
    };
    ValidationsClientService.prototype.getValidationRulesInternal = function (request) {
        return toNative(this.requestClient.get(ValidationConstants.Urls.GetValidationRules, request));
    };
    ValidationsClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient,
            BindingEngine])
    ], ValidationsClientService);
    return ValidationsClientService;
}());
export { ValidationsClientService };
